<template>
    <div class="audition-bet-content">
        <template v-if="hasAttachment">
            <div class="text-block bet-content">{{ betContent || '-' }}</div>
            <div v-if="attachmentFileName" class="attachment-tip">
                已上传文件：{{ attachmentFileName }}
            </div>
        </template>
        <template v-else-if="conditions && conditions.length">
            <el-table :data="conditions" border size="small" class="bet-table">
                <el-table-column label="区域" prop="directionLabel" width="120" />
                <el-table-column label="条件" min-width="100">
                    <template slot-scope="{ row }">
                        {{ row.conditionLabel || row.conditionCode || '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="选号" min-width="240">
                    <template slot-scope="{ row }">
                        <span v-html="formatNumbers(row)"></span>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <div v-else class="text-block bet-content">{{ betContent || '-' }}</div>
    </div>
</template>

<script>
export default {
    name: 'AuditionBetContent',
    props: {
        betConditions: { type: Array, default: () => [] },
        betContent: { type: String, default: '' },
        attachmentFileName: { type: String, default: '' },
        hasAttachment: { type: Boolean, default: false },
        preType: { type: String, default: '' }
    },
    computed: {
        conditions () {
            return this.betConditions || []
        }
    },
    methods: {
        formatNumbers (row) {
            const expand = row.expand || ''
            if (!expand) return '-'
            const label = (row.directionLabel || '').toLowerCase()
            const isBlue = label.includes('蓝') || label.includes('后区')
            const color = isBlue ? '#2899DF' : '#f00'
            return expand.split(/\s+/).filter(Boolean).map(n =>
                `<span style="color:${color};margin-right:6px;">${n}</span>`
            ).join('')
        }
    }
}
</script>

<style lang="scss" scoped>
.audition-bet-content {
    width: 100%;
}
.bet-table {
    width: 100%;
}
.text-block.bet-content {
    white-space: pre-wrap;
    word-break: break-all;
    line-height: 1.6;
    max-height: 300px;
    overflow-y: auto;
    padding: 10px 12px;
    background: #f7f8fa;
    border-radius: 4px;
}
.attachment-tip {
    margin-top: 8px;
    font-size: 13px;
    color: #666;
}
</style>
